import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronDown,
  faChevronRight,
  faChevronUp, // <-- Import the 'up' icon
} from "@fortawesome/free-solid-svg-icons";
import DriveFile from "../../../../../interfaces/file/DriveFile";
import { formatDateTime } from "../../../../../utilities/dateUtils";
import { formatFileSize } from "../../../../../utilities/fileUtils";
import { useNavigate } from "react-router-dom";
import { Stack } from "react-bootstrap";
import { SignatureStatus } from "../../../../../interfaces/file/fileSignature/SignatureBox";

interface DocumentInfoProps {
  // 1. Update the prop to accept an array of versions
  fileMetadata: DriveFile | null;
  activeNav: string | null;
  toggleNav: (nav: string) => void;
   status?: SignatureStatus;
   taskId? : number | null;
   taskTitle? : string | null;
}

const DocumentInfo: React.FC<DocumentInfoProps> = ({
  fileMetadata,
  activeNav,
  toggleNav,
  status,
  taskId,
  taskTitle
}) => {

  const navigate = useNavigate();

  const [isVersionHistoryVisible, setVersionHistoryVisible] = useState(false);

  const currentVersion = fileMetadata;

  const toggleVersionHistory = () => {
    setVersionHistoryVisible(!isVersionHistoryVisible);
  };

  return (
    <div>
      <div
        className="top top_bar_flx border_tittle cursor-pointer"
        onClick={() => toggleNav("document")}
      >
        <div className="top_bar_tittle">
          <h2>Document</h2>
        </div>
        <FontAwesomeIcon
          className="text-inactive cursor-pointer"
          icon={activeNav === "document" ? faChevronDown : faChevronRight}
        />
      </div>
      {activeNav === "document" && (
        <div className="document_stats_grid mb-3">
          {/* The component now displays data from the 'currentVersion' */}
                {
                      status &&
                      <Stack
                          direction="horizontal"
                          gap={2}
                          className="er_si_status_wrapper"
                      >
                          <span
                              className={`er_si_status_dot ${status === "pending" ? "pending" : "success"
                                  }`}
                          />
                          <span className="er_si_status_text">
                              {status === "pending"
                                  ? "Pending Signature"
                                  : "Signature Completed"}
                          </span>
                      </Stack>

                }

                  {
                      taskTitle && (
                          <div className="stats">
                              <h3>Task Title</h3>
                              <p>{taskTitle || "N/A"}</p>
                          </div>
                      )
                  }

                  {taskId && (
                      <div className="stats">
                          <h3>Task Id</h3>
                          <p>{taskId || "N/A"}</p>
                      </div>
                  )}
    
          <div className="stats">
            <h3>File Type</h3>
            <p>{currentVersion?.mimeType || "N/A"}</p>
          </div>
          <div className="stats">
            <h3>File Name</h3>
            <p style={{ wordBreak: "break-word" }}>{currentVersion?.fileName}</p>
          </div>
          <div className="stats">
            <h3>Created</h3>
            <p>
              {currentVersion?.createDate
                ? formatDateTime(new Date(currentVersion.createDate))
                : "N/A"}
            </p>
          </div>
          <div className="stats">
            <h3>Last Updated</h3>
            <p>
              {currentVersion?.updateDate
                ? formatDateTime(new Date(currentVersion.updateDate))
                : "N/A"}
            </p>
          </div>
          <div className="stats">
            <h3>File Size</h3>
            <p>{formatFileSize(currentVersion?.size || 0)}</p>
          </div>

          {/* 4. This is the updated, clickable Version section */}
          <div className="stats">
            <h3 className="font-bold">Version</h3>
            <div
              onClick={toggleVersionHistory}
              className="flex justify-between items-center cursor-pointer"
            >
              <p className="font-semibold">
                {currentVersion?.versionId
                  ? "v" + currentVersion.versionId
                  : "v1"}
              </p>
              <FontAwesomeIcon
                className="text-inactive"
                icon={isVersionHistoryVisible ? faChevronUp : faChevronDown}
              />
            </div>

            {/* 5. Conditionally render the list of all versions */}
            {isVersionHistoryVisible && fileMetadata && (
              <ul className="mt-2 list-none p-0 border-t">
                {fileMetadata.versionHistory && fileMetadata.versionHistory.map((version) => (
                  <li
                    key={version.versionId}
                    className="py-1 text-sm flex justify-between"
                  >
                    <span className="text-primary cursor-pointer" onClick={() => navigate(`/view/file/${version.fileID}`)}>v{version.versionId}</span>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default DocumentInfo;